export const TYPES = {
  26: {
    name: 'fullname',
    id: 'accountId',
  },
  27: {
    name: 'departmentName',
    id: 'departmentId',
  },
  48: {
    name: 'organizeName',
    id: 'organizeId',
  },
};

export const AREA = [19, 23, 24];

export const PARTICULARLY_CITY = ['110000', '120000', '310000', '500000', '810000', '820000'];
